import i18n from '../i18n';

const getErrorMessage = (error) => {
  if (error && error.response && error.response.data && error.response.data.message) {
    const key = error.response.data.message;
    const message = i18n.t(`errorMessages.${key}`);
    return message !== `errorMessages.${key}` ? message : i18n.t('errorMessages.unknowError');
  }
  if (error.message) {
    return error.message;
  }
  return i18n.t('errorMessages.unknowError');
};

export { getErrorMessage };
